<template>
  <div class="pa-0 ma-0 fill-height" style="background-color:#f5f5f5" fluid>
    <v-content>
      <v-container fluid>
        <div class="pt-5 pb-0"><p class="display-1 font-weight-medium pb-0"><span class="pt-2">Pipelines </span>
          <span class="pt-0 mt-0">
          <v-dialog v-model="explainer">
            <v-card flat class="pa-0">
            <v-card-text color="secondary" class="pl-3 pt-0">
              <v-list>
                  <v-list-item class="title">Pipelines Explained</v-list-item>
                  <v-list-item>
                    <v-card flat tile class="pl-1">
                      <p style="color:#12253a;">
                        You can build one or more pipelines by adding any contracts, tenders or grants of interest to one of your pipelines. This gives you quick access to the notices whenever you need them as well as provide analysis of the overall pipeline.
                      </p>
                      <p style="color:#12253a;">
                        To start building a pipeline:
                        <ul>
                          <li>Create a pipeline by clicking on the "+ Pipeline" button and naming the pipeline, for example "Q4 Target Contracts".
                          </li>
                          <li>Use the advanced search to find contracts of interest and then click the
                            <v-icon small color="secondary">mdi-checkbox-blank-outline</v-icon> button to add that contract to one or more pipelines.
                          </li>
                        </ul>
                      </p>
                      <p>
                        <router-link target="_blank" :to="{ name: 'search',
                                            query: {
                                              disposition: ['Contract Notice', 'Grant'],
                                              expiry_from: new Date().getFullYear(),
                                              expiry_to: new Date().getFullYear(),
                                              sort_order: 'asc'
                                            }
                                          }"
                        >Click <span color="primary">here</span> to start exploring contracts.</router-link>
                      </p>
                    </v-card>
                  </v-list-item>
                </v-list>
            </v-card-text>
          </v-card>
        </v-dialog>
          <v-icon medium color="secondary" @click="explainer = true">mdi-information-outline</v-icon>
          
          
          </span></p></div>
          <v-row class="pt-0"><v-col class="pt-0" cols="12"><span class="subtitle">Total Contract Value <b>{{ totalPipeline }}</b></span></v-col></v-row>
          
          <v-row
            class="py-0"
            style="height: 100%;"
          >
          <v-col cols="10" class="pt-0 pb-0">
                <v-combobox
                      v-model="selected_pipelines"
                      :items="pipelines"
                      :loading="loadingSearches"
                      :search-input.sync="search"
                      item-text="name"
                      label="Select one or more profiles to compare"
                      outlined
                      chips
                      dense
                      solo
                      multiple
                      return-object
                      
                    >
                    <template v-slot:selection="{ attrs, item, select, selected }">
                      <v-chip
                        label
                        color="rgb(255, 20, 99)"
                        class="accent white--text"
                        small
                        v-bind="attrs"
                        :input-value="selected"
                        close
                        @click="select"
                        @click:close="remove_profile(item)"
                        ><span class="chip-label">{{ item.name }}</span></v-chip
                      >
                  </template>
              </v-combobox>
            </v-col>
            <v-col cols="2" class="pt-0 pb-0">
              <v-btn color="white" @click="newPipeline=true"><v-icon>mdi-plus</v-icon> Pipeline</v-btn>
          </v-col>
        </v-row>


        <v-row v-if="selected_pipelines.length == 0">
          <v-col>
            <v-card flat tile class="pl-1">
              <v-card-text color="secondary">
                <v-list>
                  <v-list-item class="title">Pipelines Explained</v-list-item>
                  <v-list-item>
                    <v-card flat tile class="pl-1">
                      <p style="color:#12253a;">
                        You can build one or more pipelines by adding any contracts, tenders or grants of interest to one of your pipelines. This gives you quick access to the notices whenever you need them as well as provide analysis of the overall pipeline.
                      </p>
                      <p style="color:#12253a;">
                        To start building a pipeline:
                        <ul>
                          <li>Create a pipeline by clicking on the "+ Pipeline" button and naming the pipeline, for example "Q4 Target Contracts".
                          </li>
                          <li>Use the advanced search to find contracts of interest and then click the
                            <v-icon small color="secondary">mdi-bookmark-outline</v-icon> button to add that contract to one or more pipelines.
                          </li>
                        </ul>
                      </p>
                      <p>
                        <router-link :to="{ name: 'search',
                                            query: {
                                              disposition: ['Contract Notice', 'Grant'],
                                              expiry_from: new Date().getFullYear(),
                                              expiry_to: new Date().getFullYear(),
                                              sort_order: 'asc'
                                            }
                                          }"
                        >Click here to start exploring contracts.</router-link>
                      </p>
                    </v-card>
                  </v-list-item>
                </v-list>
              </v-card-text>
                  </v-card>
            </v-col>
        </v-row>
          <v-row v-else v-for="selected_pipeline in selected_pipelines" :key="selected_pipeline.id" class="pb-3">
            <v-col v-if="selected_pipeline['search_query']" cols="12" class="pt-0 pb-0">
              <v-card width="100%" flat outlined>
                <v-card-title class="pt-3 pb-5 pl-6" style="font-weight:medium !important; color: #12253a !important;">
                  <span>
                    <v-card-subtitle color="secondary" class="pa-0 font-weight-light">Pipeline</v-card-subtitle>
                    <span
                      class="pt-0 text--primary cursor-pointer"
                      @click="openProfile(0, selected_pipeline)"
                    >
                      {{ selected_pipeline.name }}
                    </span>
                    </span>
                    <div class="flex-grow-1"></div>
                    <span>
                      <v-tooltip left max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon>
                              <v-icon v-bind="attrs" v-on="on" medium color="primary">mdi-information-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>What data is this pipeline based on?</span
                            >
                            <br />
                            <v-divider class="mt-2 mb-2" style="border-color:white;"></v-divider>
                            <span>This pipeline is an aggregate view of contracts and other notices added to the pipeline.</span>
                            <div></div>
                        </v-tooltip>
                    </span>
                    <span>
                      <v-tooltip left max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="openProfile(0, selected_pipeline)" icon>
                              <v-icon v-bind="attrs" v-on="on" medium color="secondary">mdi-format-list-bulleted</v-icon>
                            </v-btn>
                          </template>
                          <span>Go to the list of contracts in this pipeline</span>
                        </v-tooltip>
                    </span>
                    <span>
                      <v-tooltip left max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="openProfile(1, selected_pipeline)" icon>
                              <v-icon v-bind="attrs" v-on="on" medium color="secondary">mdi-sort-variant</v-icon>
                            </v-btn>
                          </template>
                          <span>Go to the leaderboard for this pipeline</span>
                        </v-tooltip>
                    </span>
                    <span>
                      <v-tooltip left max-width="300">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="openProfile(3, selected_pipeline)" icon>
                              <v-icon v-bind="attrs" v-on="on" medium color="secondary">mdi-chart-box-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Go to the analysis for this pipeline</span>
                        </v-tooltip>
                    </span>
                    <span>
                    <v-tooltip top dark color="#000000" style="opacity: 0.7;">
                      <template v-slot:activator="{ on }">
                        <v-btn right icon @click="selectedItem = selected_pipeline, deleteList = true" v-on="on">
                          <v-icon medium color="primary">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete pipeline</span>
                    </v-tooltip>
                  </span>

                </v-card-title>
                <v-card-text v-if="parseJSON(selected_pipeline.search_query).tender_id.length > 0" class="px-5 pt-0">
                  <v-row class="pa-0">
                    <v-col cols="12" sm="12">
                      <search-analysis :query="parseJSON(selected_pipeline.search_query)" />
                    </v-col>
                  </v-row>
                  <v-row class="pa-0">
                    <v-col class="pl-0" cols="12" sm="3">
                      <!-- <spend-comparison-mini
                        :title="'Quarterly Spend'" :description="''" :query="selected_pipeline.search_query"
                      /> -->
                      <spending-donut-mini
                        :title="'Government'" :description="''" :query="selected_pipeline.search_query" :group="{text: 'Government', value: 'government'}"
                      />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <spending-donut-mini
                        :title="'Top Categories'" :description="''" :query="selected_pipeline.search_query" :group="{text: 'Major Category', value: 'major_category'}"
                      />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <spending-donut-mini
                        :title="'Top Suppliers'" :description="''" :query="selected_pipeline.search_query" :group="{text: 'Supplier', value: 'supplier'}"
                      />
                    </v-col>
                    <v-col cols="12" sm="3">
                      <spending-donut-mini
                        :title="'Top Buyers'" :description="''" :query="selected_pipeline.search_query" :group="{text: 'Buyer', value: 'publisher'}"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text v-else class="px-5 pt-0">
                  <router-link :to="{ name: 'search',
                                            query: {
                                              disposition: ['Contract Notice', 'Grant'],
                                              expiry_from: new Date().getFullYear(),
                                              expiry_to: new Date().getFullYear(),
                                              sort_order: 'asc'
                                            }
                                          }"
                        >Click <span class="red--text">here</span> to start building this pipeline.</router-link>
                </v-card-text>
              </v-card>
            </v-col>
            
          </v-row>
      </v-container>
      <v-dialog v-model="deleteList" max-width="500" absolute>
      <v-card>
        <p class="title mx-auto pa-3">
          <span>Delete pipeline </span> <span class="title" v-if="selectedItem"> "{{selectedItem["name"]}}"</span>?
        </p>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="deleteList = false">
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            text
            @click="(deleteList = false), removeList(selectedItem.id)"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="400" v-model="newPipeline">
        <v-card flat>
          <v-card-title>Create a new Pipeline
            <div class="flex-grow-1"></div> <v-btn icon @click="newPipeline=!newPipeline"><v-icon medium>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
            <v-text-field
                
                v-model="new_list_name"
                solo-inverted
                hide-details
                flat
                label="New pipeline name..."
                class="pa-5"
              ></v-text-field>

              <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="danger" text @click="addList(), newPipeline=!newPipeline">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import { getListItemsQuery, deleteList, createNewList } from "../components/APIManager.js";
import SearchAnalysis from "../components/SearchAnalysis.vue";
import SpendingDonutMini from "../components/SpendingDonutMini.vue";
//import SpendComparisonMini from "../components/SpendComparisonMini.vue";
import { getInstance } from "../auth/index.js";
import { parseJSON, numFormatter, formattedCurrency } from "../components/Utils.js";
import axios from "axios";

export default {
  components: {
    SearchAnalysis,
    SpendingDonutMini
  },

  data() {
    return {
      new_list_name: "",
      selectedItem: null,
      newPipeline: false,
      explainer: false,
      search: String(),
      stats: {},
      selected_pipelines: [],
      pipelines: [],
      loadingSearches: Boolean(),
      errored: Boolean(),
      deleteList: false,
      cards: [
        {
          title: "Open tenders",
          src: "requests.png",
          flex: 3,
          id: 0
        },
        {
          title: "Competitor contracts",
          src: "competitorcontracts.png",
          flex: 3,
          id: 1
        },
        {
          title: "Partnership opportunities",
          src: "networkmin.png",
          flex: 3,
          id: 2
        }
      ],
      changed: Number
    };
  },

  computed: {
    imgSourced() {
      return "@/assets/img/requests.png";
    },

    totalPipeline(){
      const totalGroupValue = this.pipelines.reduce((sum, pipeline) => sum + (pipeline.group_value || 0), 0);
      return formattedCurrency(totalGroupValue);
    }
  },

  mounted(){
    this.loadingSearches = true;
    this.getLists();

  },

  methods: {

    parseJSON,

    addList() {
      if (!this.new_list_name) {
        var dialog = {};
        dialog.msg = "Please enter a valid list name";
        dialog.title = "No data provided";
        dialog.state = true;

        bus.$emit("show_dialog", dialog);
      } else {
        createNewList(this.new_list_name)
          .then(data => {
            this.getLists();
            this.new_list_name = "";
            bus.$emit("update-propsect-lists", true);
          })
          .catch(error => {
            var dialog = {};
            dialog.msg = "We encountered an issue saving your new list. Please try again.";
            dialog.title = "Attempted save failed.";
            dialog.state = true;
          });
      }
    },

    remove_profile(item) {
      this.selected_pipelines.splice(
        this.selected_pipelines.indexOf(item),1);
      this.selected_pipelines = [...this.selected_pipelines];
    },

    openProfile(viewIndex, pipeline) {
      var qry = this.parseJSON(pipeline.search_query);

      qry["viewIndex"] = viewIndex;

      const routeData = this.$router.resolve({ path: "/search", query: qry });
      window.open(routeData.href, '_blank');
      //bus.$emit("load-filters", JSON.parse(query));
    },

    refresh(){
      this.setChanged();
    },

    setChanged(){
      this.changed =
          (Math.random() + this.chart_data.data.length) * Math.random();
      //this.generate_json();
    },

    removeList(list_id) {
      this.loading = true;
      this.selected_pipelines = [];

      deleteList(list_id)
        .then(data => {
          this.deleted_list = data;
          this.getLists();
        })
        .catch(error => {
          error;
        });
    },

    async getLists() {
      const instance = getInstance();
      const accessToken = await instance.getTokenSilently();
      axios
        .get(process.env.VUE_APP_API_LISTS, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        })
        .then(response => {
          this.pipelines = response.data.data;
          this.selected_pipelines = [];
          this.selected_pipelines.push(this.pipelines[0]);
          this.loading = false;
        })
        .catch(error => {
          this.errored = true;
        })
        .finally(() => (this.loadingSearches = false));
    },

    numFormatter(num) {
      if (num > 999 && num < 1000000) {
        return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
      } else if (num > 1000000 && num < 1000000000) {
        return (num / 1000000).toFixed(0) + "M"; // convert to M for number from > 1 million
      } else if (num > 1000000000) {
        return (num / 1000000000).toFixed(0) + "B"; // convert to M for number from > 1 million
      } else if (num < 900) {
        return num; // if value < 1000, nothing to do
      }
    },

    future() {
      var d = new Date();
      var year = d.getFullYear();
      var month = d.getMonth();
      var day = d.getDate();
      var future = new Date(year + 10, month, day);
      return future.toISOString().substr(0, 10);
    },

    today() {
      var dte = new Date();
      return dte.toISOString().substr(0, 10);
    },

    imgSource() {
      var src;
      switch (id) {
        case 0:
          src = "@/assets/img/requests.png";
          ////////console.log(src);
          break;
        case 1:
          src = "@/assets/img/competitorcontracts.png";
          break;
        case 2:
          src = "@/assets/img/networkmin.png";
          break;
      }

      return src;
    }
  },

  async created() {
    //this.stats = await getStats();
    ////////console.log(JSON.stringify(this.stats));
  }
};
</script>

<style scoped>
.chip-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.searchBackground::after {
  background-image: url("../assets/img/background.ef1dd5e2.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  content: "";
  opacity: 0.09;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}

.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url("../assets/img/networkbanner.png") no-repeat center center;
  background-size: inherit;
  transform: scale(1.1);
  opacity: 0.09;
}

#linkhover:hover {
  text-decoration: underline !important;
}
</style>
